import './console-error-normalized-polyfill.js';

export type NormalizedError = Error & {
  code?: string | number;
  status?: number;
  config?: unknown;
  response?: unknown;
  request?: unknown;
  data?: unknown;
  packageName?: string;
  workspaceId?: string;
  role?: string;
  content?: unknown;
  toolCalls?: unknown;
  user?: unknown;
  id?: string | number;
  mode?: string;
  delta?: unknown;
  title?: string;
  description?: string;
  [key: string]: unknown;
};

export function normalizeError(input: unknown): NormalizedError {
  if (input instanceof Error) {
    return input as NormalizedError;
  }
  if (typeof input === 'object' && input !== null) {
    const normalized = new Error('Unknown error') as NormalizedError;
    Object.assign(normalized, input);
    return normalized;
  }
  return new Error(String(input)) as NormalizedError;
}


